/**
 * @desc Wait a value from callback
 * @param callback {Function} - Function witch returns a wait value
 * @param timeOfWait { Number } - Time of wait min 100
 * @returns {Promise<unknown>}
 */
const waitValue = (callback, timeOfWait = 60000) => {
  const startTime = new Date()
  const wait = (resolve, reject) => {
    setTimeout(() => {
      try {
        let result = callback()
        if (result) {
          resolve(result)
        } else if (new Date() - startTime > timeOfWait) {
          reject(new Error(`Wait => ${timeOfWait}`))
        } else {
          wait(resolve, reject)
        }
      } catch (e) {
        reject(e)
      }
    }, 100)
  }
  return new Promise((resolve, reject) => {
    wait(resolve, reject)
  })
}
/**
 * @desc Return a promise which will be resolve after delay [ms]
 * @param delay {Number} - delay to resolve promise [ms]
 * @returns {Promise<unknown>} - resolved promise
 */
const delayPromise = (delay = 300) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, delay)
  })
}
const promiseListCallback = (callbackList = []) => {
  let promise = Promise.resolve()
  callbackList.forEach((promisesItemCallback) => {
    promise = promise
      .then(() => {
        if (typeof promisesItemCallback === 'function') {
          return promisesItemCallback()
        } else {
          console.warn(`promisesItemCallback is not function`)
          return promisesItemCallback
        }
      })
  })
  return promise
}
export {
  promiseListCallback,
  delayPromise,
  waitValue
}
